import { MountingType } from './SystemDesigns';

export enum domesticContentStatusKeys {
  approvedSolarOnly = 'approvedSolarOnly',
  rejectedSolarOnly = 'rejectedSolarOnly',
  approvedStorageOnly = 'approvedStorageOnly',
  rejectedStorageOnly = 'rejectedStorageOnly',
  approvedSolarAndStorage = 'approvedSolarAndStorage',
  rejectedSolarAndStorage = 'rejectedSolarAndStorage',
  optOut = 'optOut',
}

export enum DomesticContentApprovalReasons {
  approvedSolarOnly = 'Approved Solar Only',
  approvedStorageOnly = 'Approved Storage Only',
  approvedSolarAndStorage = 'Approved Solar + Storage',
}

export enum DomesticContentRejectionReasons {
  rejectedSolarOnly = 'Rejected Solar Only',
  rejectedStorageOnly = 'Rejected Storage Only',
  rejectedSolarAndStorage = 'Rejected Solar + Storage',
  optOut = 'Opted Out',
}

/**
 * Members use string literals rather than references to {@link DomesticContentApprovalReasons} /
 * {@link DomesticContentRejectionReasons} to avoid reverse mappings emitted by the oxc transformer
 * (used by Vite 8 / Rolldown) when initializers are cross-enum references.
 * @see https://github.com/Palmetto-Sabal/sabal/pull/6104
 */
export enum DomesticContentReviewStatusForSolarOnly {
  approvedSolarOnly = 'Approved Solar Only',
  rejectedSolarOnly = 'Rejected Solar Only',
}

/**
 * Members use string literals rather than references to {@link DomesticContentApprovalReasons} /
 * {@link DomesticContentRejectionReasons} to avoid reverse mappings emitted by the oxc transformer
 * (used by Vite 8 / Rolldown) when initializers are cross-enum references.
 * @see https://github.com/Palmetto-Sabal/sabal/pull/6104
 */
export enum DomesticContentReviewStatusForStorageOnly {
  approvedStorageOnly = 'Approved Storage Only',
  rejectedStorageOnly = 'Rejected Storage Only',
}

/**
 * Members use string literals rather than references to {@link DomesticContentApprovalReasons} /
 * {@link DomesticContentRejectionReasons} to avoid reverse mappings emitted by the oxc transformer
 * (used by Vite 8 / Rolldown) when initializers are cross-enum references.
 * @see https://github.com/Palmetto-Sabal/sabal/pull/6104
 */
export enum DomesticContentReviewStatusForSolarAndStorage {
  approvedSolarAndStorage = 'Approved Solar + Storage',
  rejectedSolarAndStorage = 'Rejected Solar + Storage',
  rejectedStorageOnly = 'Rejected Storage Only',
  rejectedSolarOnly = 'Rejected Solar Only',
}

export enum AttestmentTypeLabelMap {
  pvOnly = 'Solar Only',
  storageOnly = 'Storage Only',
  pvAndStorage = 'Solar + Storage',
  optOut = 'Opted Out',
}

/** @deprecated Use itcQualification instead */
export interface DCQualificationResponse {
  calculatorVersion: Date;
  timestamp: Date;
  batteryQualified: boolean;
  batteryPercentage: number;
  batteryPercentageThreshold: number;
  inverterPercentage: number;
  panelPercentage: number;
  rackingRailPercentage: number;
  rackingFastenerPercentage: number;
  rackingClampPercentage: number;
  rackingSplicePercentage: number;
  rackingBonusPercentage: number;
  pvQualified: boolean;
  pvTotalPercentage: number;
  pvSystemPercentageThreshold: number;
  problems: string[];
  warnings: string[];
}

export interface ITCQualificationResponse extends DCQualificationResponse {
  safeHarborYear?: number;
  pvSystemFeocPercentageThreshold: number;
  batteryFeocPercentageThreshold: number;
  batteryFeocPercentage: number;
  batteryFeocQualified: boolean;
  inverterFeocPercentage: number;
  rackingRailFeocPercentage: number;
  rackingTotalFastenerPercentage: number;
  rackingTotalFastenerFeocPercentage: number;
  rackingFastenerFeocPercentage: number;
  rackingClampFeocPercentage: number;
  rackingSpliceFeocPercentage: number;
  rackingBonusFeocPercentage: number;
  panelFeocPercentage: number;
  pvTotalFeocPercentage: number;
  pvFeocQualified: boolean;
  batteryIncluded: boolean;
  feocExceptionGranted?: boolean;
  equipmentExceptionGranted?: boolean;
}

export interface Equipment {
  manufacturer: string;
  sku: string;
  vintage?: string;
}

export interface EnphaseAttestations {
  enphaseInverterAttested?: boolean;
  enphaseStorageAttested?: boolean;
}

export interface EquipmentList {
  mountingType: MountingType;
  panel: Equipment;
  inverters: Equipment[];
  rackingClamp?: Equipment[];
  rackingFastener?: Equipment[];
  rackingRail?: Equipment[];
  rackingSplice?: Equipment[];
  batteries?: Equipment[];
  enphaseAttestations?: EnphaseAttestations;
}

/** @deprecated For old DC use. Use {@link EquipmentList} instead. */
export interface DcEquipmentList {
  mountingType: MountingType;
  panel: Equipment;
  inverters: Equipment[];
  rackingClamp?: Equipment;
  rackingFastener?: Equipment;
  rackingRail?: Equipment;
  rackingSplice?: Equipment;
  batteries?: Equipment[];
}

export type ItcPercentProperty = {
  dcPercentProperty: 'domesticContentPercentageMlpe' | 'domesticContentPercentageString';
  feocPercentProperty: 'feocPercentageMlpe' | 'feocPercentageString';
};

export enum InverterType {
  string = 'string',
  mlpe = 'mlpe',
}
